import { render, staticRenderFns } from "./FormCourse.vue?vue&type=template&id=35b3ecc9&scoped=true&"
import script from "./FormCourse.vue?vue&type=script&lang=js&"
export * from "./FormCourse.vue?vue&type=script&lang=js&"
import style0 from "./FormCourse.vue?vue&type=style&index=0&id=35b3ecc9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b3ecc9",
  null
  
)

export default component.exports